import { SettlementAccountStatus } from "types/stripe";
import {
  getMoneySettlementAccountStatus,
  onboardMerchant,
  getStripeDashboardLink as getStripeDashboardLinkApi,
} from "utils/AxiosUtil";

async function getAccountStatus(
  merchantId: string,
): Promise<SettlementAccountStatus> {
  const res = await getMoneySettlementAccountStatus(merchantId);
  return res.data;
}

async function createAccount(
  merchantId: string,
): Promise<SettlementAccountStatus> {
  const res = await onboardMerchant(merchantId);
  return res.data;
}

async function getDashboardLink(merchantId: string): Promise<string> {
  const res = await getStripeDashboardLinkApi(merchantId);
  return res.data.url;
}

const stripe_services = {
  getAccountStatus,
  createAccount,
  getDashboardLink,
};

export default stripe_services;
